const data = [
    {
      id: 1,
      image: "images/sudivg.jpg",
      title: "Suvdivguide - Website",
      link: "https://sudivguide.com",
    },
    {
      id: 2,
      image: "images/sudivguidef.jpg",
      title: "lacc.me - Google Ads Performance",
      desc: "Run an advertisement on Google for students looking for BBA and MBA degrees and it is ranking in 3rd position.",
      link: "https://lacc.me/",
    },
    {
      id: 3,
      image: "images/sudivp.jpg",
      title: "Sudivguide - Pinterest",
      desc: "Through SUDIVEGUIDE, students in classes 1, 2, and 3 can access essays, GK questions, kid-friendly vocabulary, math, and rhymes. We have developed an innovative writing style for students that they will find simpler to read and comprehend.",
      link: "https://www.pinterest.com/sudivguide/",
    },
   
  ]
  export default data